// extracted by mini-css-extract-plugin
export default {"paper":"InCallFaxesDialog_paper__NJqpk","header":"InCallFaxesDialog_header__0Ez1S","content":"InCallFaxesDialog_content__h+9AE"};